import { render, staticRenderFns } from "./WMenuValidationAction.vue?vue&type=template&id=825d5c80&scoped=true&"
import script from "./WMenuValidationAction.vue?vue&type=script&lang=js&"
export * from "./WMenuValidationAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825d5c80",
  null
  
)

export default component.exports